// ======================================================================
// File Name       : email
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function getEmailList(data) {
  return commonCallApi({
    path: 'email/GetList',
    data: { ...data },
  });
}

export function postReservedEmailList(data) {
  return commonCallApi({
    path: 'email/GetReservedList',
    data: { ...data },
  });
}

export function postSaveReceiver(data) {
  return commonCallApi({
    path: 'email/SaveReceiver',
    data: { ...data },
  });
}

export function postEmailEdit(editType, data) {
  return commonCallApi({
    path: 'email/Edit',
    data: {
      editType,
      emailInfo: data,
    },
  });
}
